module.exports = __webpack_public_path__ + "static/media/commercial-laundry-new.26a68e3f.jpg";